export default __webpack_public_path__ + "static/media/edit.6747cb4b.svg";